// extracted by mini-css-extract-plugin
export default {"block":"Result_block__44PaG"};